export default {
  dataInicial: {
    value: '',
    required: true,
    state: null
  },
  dataFinal: {
    value: '',
    required: true,
    state: null
  },
  valor: {
    value: 0,
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/kmValue/components/add/kmValue-form.js